<span class="ey-notification-icon-container">
  <div class="ey-notification-icon-button">
    <span class="ey-notification-icon-button-wrapper">
      <i class="ey-notification-icon material-icons">notifications</i>
      <span *ngIf="notificationCount > 0" class="ey-notification-count-badge">{{ notificationCount }}</span>
    </span>
  </div>
</span>
